import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Data } from '@angular/router';
import { forkJoin, from, map, of } from 'rxjs';
import { getFullPath } from '../lib/get-full-path';
import { PublicTenantService } from './public-tenant.service';

@Injectable({
  providedIn: 'root',
})
export class GenericReplaceService {
  private publicTenantService = inject(PublicTenantService);
  private keys = [
    { key: 'currentYear', value: new Date().getFullYear().toString() },
    {
      key: 'tenant.owner_first_name',
      value: 'FROM_ROUTE',
    },
    {
      key: 'tenant.logo_url',
      value: 'FROM_ROUTE',
    },
    {
      key: 'tenant.name',
      value: 'FROM_ROUTE',
    },
    {
      key: 'tenant.owner_avatar_url',
      value: 'FROM_ROUTE',
    },
    {
      key: 'tenant.id',
      value: 'FROM_ROUTE',
    },
    {
      key: 'current_page_number',
    },
  ];

  replaceFactory(route: ActivatedRouteSnapshot, routeData: Data) {
    return (text: string) => {
      if (!text) return text;
      this.keys.forEach(item => {
        if (item.value === 'FROM_ROUTE') {
          const objKey = item.key.split('.')[0];
          const obj = routeData[objKey];
          if (!obj) return text;
          const key = item.key.split(`.`)[1];
          text = text.replaceAll(`{{${item.key}}}`, obj[key] || '');
        }

        if (item.key === 'current_page_number') {
          let pageText = '1';
          const path = getFullPath(route, false);
          const last = path.pop();
          if (last?.startsWith('page-')) {
            const page = parseInt(last.split('page-')[1], 10);
            pageText = page.toString();
          }
          text = text.replaceAll(`{{${item.key}}}`, pageText);
          return;
        }

        text = text.replaceAll(`{{${item.key}}}`, item.value);
      });
      return text;
    };
  }

  getFromKeyFactory(route: ActivatedRouteSnapshot, routeData: Data) {
    return (key: string) => {
      if (key === 'tenant') return { content: routeData.tenant };
    };
  }

  private getPublicTenant(route: ActivatedRouteSnapshot) {
    if (!route.queryParams.tenant) return of(undefined);
    return from(this.publicTenantService.getTenant(route.queryParams.tenant));
  }

  public getGenericReplaceData(route: ActivatedRouteSnapshot) {
    return forkJoin([this.getPublicTenant(route)]).pipe(
      map(([tenant]) => ({
        tenant,
      }))
    );
  }
}
